export default {
  titleResource: 'Eliminar recurso',
  titleContent: 'Eliminar contenido',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  deleteResourceDescription: 'Elige el idioma del recurso que deseas eliminar. Si eliminas todos los idiomas, se eliminará el recurso por completo.',
  deleteContentDescription: 'Elige el idioma del contenido que desees eliminar. Al eliminar todos los idiomas se eliminará el contenido por completo',
  deletePlaceholder: 'Selecciona un idioma',
  confirmError: 'El texto ingresado no coincide con lo esperado',
  confirmResource: 'Para confirmar, escribe debajo <i>"borrar recurso"</i>',
  confirmContent: 'Para confirmar, escribe debajo <i>"borrar contenido"</i>',
  confirmResourceValue: 'borrar recurso',
  confirmContentValue: 'borrar contenido'
}

export const en = {
  titleResource: 'Delete resource',
  titleContent: 'Delete content',
  cancel: 'Cancel',
  delete: 'Delete',
  deleteResourceDescription: 'Choose the language of the resource you want to delete. Deleting all languages will delete the resource completely.',
  deleteContentDescription: 'Choose the language of the content you want to delete. Deleting all languages will delete the content completely.',
  deletePlaceholder: 'Select a language',
  confirmError: 'The entered text does not match the expected',
  confirmResource: 'To confirm, type below <i>"delete resource"</i>',
  confirmContent: 'To confirm, type below <i>"delete content"</i>',
  confirmResourceValue: 'delete resource',
  confirmContentValue: 'delete content'
}

export const ca = {
  titleResource: 'Eliminar recurs',
  titleContent: 'Eliminar contingut',
  cancel: 'Cancel·lar',
  delete: 'Eliminar',
  deleteResourceDescription: 'Tria l\'idioma del recurs que desitgis eliminar. En eliminar tots els idiomes s\'eliminarà el recurs per complet',
  deleteContentDescription: 'Tria l\'idioma del contingut que desitgis eliminar. En eliminar tots els idiomes s\'eliminarà el contingut per complet',
  deletePlaceholder: 'Selecciona un idioma',
  confirmError: 'El text introduït no coincideix amb l\'esperat',
  confirmResource: 'Per confirmar, escriu a continuació <i>"esborrar recurs"</i>',
  confirmContent: 'Per confirmar, escriu a continuació <i>"esborrar contingut"</i>',
  confirmResourceValue: 'esborrar recurs',
  confirmContentValue: 'esborrar contingut'
}
